import {Injectable} from '@angular/core';
import {AbstractMessageListenerService} from "./abstract-message-listener.service";
import {Router} from "@angular/router";
import {isHost} from "../shared/util/window.util";

@Injectable({
  providedIn: 'root'
})
export class StartGameMessageService extends AbstractMessageListenerService<any> {

  constructor(private router: Router) {
    super('startGame');
  }

  public override process(message: any): void {
    if (isHost()) {
      this.router.navigate(['host', this.room?.roomId, 'play']);
    } else {
      this.router.navigate(['lobby', this.room?.roomId, 'play']);
    }
  }
}
